import { makeObservable } from "@faire/web--source/common/makeObservable";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import isArray from "lodash/isArray";
import once from "lodash/once";
import { action, computed, observable } from "mobx";

import { SIGN_UP_INPUT_FIELD_ERROR } from "@faire/retailer/consts/sign-up-input-field-error";

// FIXME(refactor) This code should be refactored as the prop name does not match what the value expected
interface IFormField<ValueType> {
  value: ValueType;
  isInvalid: false | SIGN_UP_INPUT_FIELD_ERROR;
  setError: (error: string | false | undefined) => void;
  error?: string;
  selectValue: (value: ValueType) => void;
}

export class FormField<ValueType> implements IFormField<ValueType> {
  private readonly eventName: string;

  firstChangeEvent = once((query: string = "") =>
    trackEvent(`/open/${this.eventPrefix}/change/${this.eventName}${query}`)
  );

  @observable
  value: ValueType;

  @observable
  error?: string;

  @computed
  get isInvalid() {
    return this.validator(this.value);
  }

  constructor(
    value: ValueType,
    eventName: string,
    private validator: (value: ValueType) => SIGN_UP_INPUT_FIELD_ERROR | false,
    private eventPrefix: string = "sign-up"
  ) {
    makeObservable(this);
    this.value = value;
    this.eventName = eventName;

    const shouldFireEvent = isArray(value) ? value.length !== 0 : value;
    if (shouldFireEvent) {
      this.firstChangeEvent("?prefill=true");
    }
  }

  @action
  selectValue = (value: ValueType) => {
    this.firstChangeEvent();

    this.value = value;
    this.error = undefined;
  };

  @action
  setValue = (_name: string | undefined, value: ValueType) => {
    this.selectValue(value);
  };

  @action
  resetValue = (value: ValueType) => {
    this.value = value;
    this.error = undefined;
  };

  @action
  setError = (error: string | undefined | false) => {
    this.error = error ? error : undefined;
  };
}
